import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import './App.css';
import './bootstrap.min.css';
import './owl.carousel.min.css';
import './animate.min.css';

import Navbar from './Components/Navbar';
import Advertise from "./Components/Advertise";
import Home from './Components/Home';
import Fact from './Components/Facts';
import About from './Components/About';
import Footer from './Components/Footer';
import Contactbanner from "./Components/Contactbanner";
import Contact from "./Components/Contact";
import Themes from "./Components/Themes";
import Ourteam from "./Components/Ourteam";
import InfluencerDashboard from "./Components/Insights";
import Aboutbanner from "./Components/Aboutbanner";
import Servicesbanner from "./Components/Servicesbanner";
import WhatsappButton from "./Components/Whatsappbutton";
import Login from "./Adminpages/Login";
import Register from "./Adminpages/Register";

function App() {
  return (
    <div className="App">
      <Router>
        <Navbar />
        <Advertise />
        <Routes>
          <Route path="/" element={<><Home /><Fact /><About /><Ourteam /></>} />
          <Route path="/contact" element={<><Contactbanner /> <Contact /></>} />
          <Route path="/about" element={<><Aboutbanner /> <About /></>} />
          <Route path="/service" element={<><Servicesbanner /> <Ourteam /></>} />
          <Route path="/themes" element={<><Contactbanner /> <Themes /></>} />
          <Route path="/insights/:idAndSlug" element={<InfluencerDashboard />} />
          <Route path="/login" element={<><Login /></>} />
          <Route path="/register" element={<><Register /></>} />
          {/* Catch-all route to redirect to home */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
        <WhatsappButton />
        <Footer />
      </Router>
    </div>
  );
}

export default App;